/* eslint-disable @typescript-eslint/explicit-function-return-type */
import mixpanel from 'mixpanel-browser'

/**
 * Singleton for mixpanel
 *
 * uses static methods
 *
 */
export default class Mixpanel {
  private static instance: typeof mixpanel

  constructor() {
    if (!Mixpanel.instance) {
      Mixpanel.instance = this.createInstance()
    }
  }

  private createInstance() {
    const ENVIRONMENT: string = CURRENT_ENV || 'prod'

    console.log('[Mixpanel] initializing...')
    try {
      mixpanel.init(MIXPANEL_TOKEN || '', {
        debug: ENVIRONMENT !== 'prod',
        autotrack: true,
        save_referrer: true,
        track_pageview: true,
        persistence: 'localStorage',
        ignore_dnt: true,
        ...(ENVIRONMENT !== 'prod'
          ? {
              loaded: function (mxpnl) {
                console.log(
                  `[Mixpanel] loaded with distinct_id: ${mxpnl.get_distinct_id()} and user_id: ${mxpnl.get_property('user_id')} and device_id: ${mxpnl.get_property('device_id')}`,
                )
              },
            }
          : {}),
      })

      window.mixpanel = mixpanel

      console.log('[Mixpanel] initialized.')

      return window.mixpanel
    } catch (error) {
      console.warn('[Mixpanel] init failed!', error)

      delete window.mixpanel
      return null
    }
  }

  public static track(name: string, payload: any = {}): void {
    const referer =
      typeof document !== 'undefined' ? document.referrer : undefined
    const userAgent =
      typeof navigator !== 'undefined' ? navigator.userAgent : undefined
    const enrichedPayload = {
      ...payload,
      ...(referer ? { referer: referer } : {}),
      ...(userAgent ? { browser: userAgent } : {}),
    }
    Mixpanel.instance?.track(name, enrichedPayload)
  }

  public static setUser(user: {
    id: string
    name: string
    email: string
    status: string
  }): void {
    if (!Mixpanel.instance) {
      console.warn('[Mixpanel] Instance not initialized. Cannot set user.')
      return
    }

    try {
      Mixpanel.instance.identify(user.id)
      Mixpanel.instance.people.set(
        {
          name: user.name,
          email: user.email,
          status: user.status,
        },
        () => {
          console.log('[Mixpanel] User properties set successfully.')
        },
      )

      Mixpanel.instance.register({
        'Company Name': user.name,
        'Company Status': user.status,
      })

      console.log('[Mixpanel] User set successfully:', user)
    } catch (error) {
      console.error('[Mixpanel] Failed to set user:', error)
    }
  }

  public static reset(): void {
    Mixpanel.instance?.reset()
  }

  public static timeEvent(name: string): void {
    Mixpanel.instance?.time_event(name)
  }
}
